// 智芯云外部接口
import axios from 'axios'
import AuiToast from '../../assets/js/aui-toast'
import AuiDialog from '../../assets/js/aui-dialog'
import router from '../../router/index'
import store from '../../store/store'
import wx from 'weixin-js-sdk'
// 智芯云token
let zxyToken = ''

const instance = axios.create()
instance.interceptors.request.use((reqConfig) => {
  reqConfig.headers['Authorization'] = `Bearer ${zxyToken}`
  return reqConfig
}, {})
// 拦截响应response，并做一些错误处理
instance.interceptors.response.use((response) => {
  AuiToast.hide()
  AuiDialog.remove()
  return response.data
}, (err) => {
  AuiToast.hide()
  AuiDialog.remove()
  if (err && err.response) {
    switch (err.response.status) {
      case 401:
        err.message = window.vm.$i18n.t('verification.notAuthorized')
        AuiDialog.alert({
          title: window.vm.$i18n.t('verification.tips'),
          msg: window.vm.$i18n.t('verification.notAuthorized'),
          buttons: [window.vm.$i18n.t('UIComponent.sure')]
        }, function (ret) {
          if (ret.buttonIndex === 1) {
            store.state.loginUserInfor = {}
            localStorage.removeItem('loginUserInfor')
            if (window.__wxjs_environment === 'miniprogram') {
              wx.miniProgram.reLaunch({ url: `/pages/login/login` })
              return
            }
            router.replace({ path: '/login' })
            setTimeout(function () {
              location.reload()
            }, 1000)
          }
        })
        return
      case 403:
        err.message = window.vm.$i18n.t('verification.noPermission')
        break
      case 404:
        err.message = window.vm.$i18n.t('verification.requestAddressError')
        break
      case 409:
        err.message = window.vm.$i18n.t('verification.alreadyExist')
        break
      case 422:
        break
      case 500:
        err.message = window.vm.$i18n.t('verification.serverInternalError')
        break
      case 502:
        err.message = window.vm.$i18n.t('verification.gatewayError')
        break
      case 504:
        err.message = window.vm.$i18n.t('verification.requestTimeout')
        break
      default:
    }
  } else {
  }
  return Promise.reject(err)
})

/**
 * 获取设备485BMS信息-查询数据库，如果没有数据会注册轮训
 * @param {*String} sn 设备sn
 */
const getBmsInfoDb = async (sn) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) { })
  return instance.get(`/api/zxy/solar/base-bms-record/find-last-by-sn-chao-ben-le/${sn}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}

/**
 * 获取设备485BMS信息-查询设备
 * @param {*String} sn 设备sn
 */
const getBmsInfoMote = async (sn) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) { })
  return instance.get(`/api/zxy/solar/base-bms-record/load-last-by-sn-chao-ben-le/${sn}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}

/**
 * 获取设备485BMS信息-查询设备
 * @param {*String} sn 设备sn
 */
const getBmsWarnDb = async (sn) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) { })
  return instance.get(`/api/zxy/solar/base-bms-alarm-record/find-last-by-sn-chao-ben-le/${sn}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}

/**
 * 获取设备485BMS历史信息-查询设备
 * @param {*String} sn 设备sn
 */
const getBmsInfoHistory = async (options) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) { })
  return instance.post(`/api/zxy/solar/base-bms-record/statistics-data`, {
    snHex: options.snHex,
    dateTimeSingle: options.dateTimeSingle
  })
    .then(res => {
      AuiToast.hide()
      return res
    })
}

/**
 * 删除智芯云设备
 * @param {*String} sn 设备sn
 */
const deleteDeviceEmitZxy = async (snHex, projectId) => {
  // 只需要通知即可
  instance.post(`/api/zxy/solar/solar-external-import/solar-device-activate`, {
    snHex,
    projectId,
    refreshToken: 'Bearer',
    token: 'Bearer',
    isActivated: false
  })
  console.log('删除智芯云设备')
}
/**
 * 批量删除智芯云设备
 * @param {*String} sn 设备sn
 */
const deleteBatchDeviceEmitZxy = async (snHexList) => {
  // 只需要通知即可
  instance.post(`/api/zxy/solar/solar-external-import/solar-device-activate`, [...snHexList])
}
/* ====================================调用智芯云V300设备数据 BEGIN============================================= */
// 配置指令
const config = {
  waitReply: true, // 同步等待设备返回
  timeout: 3000 // 等待设备返回超时时间3秒
}
/**
 * 智芯云登录鉴权
 */
export const login = async (username) => {
  let { data } = await instance.post('/api/zxy/oauth/any-tenant/login', {
    username,
    password: '123456'
  })
  zxyToken = data.token
}
/**
 * app项目-查询项目下设备的列表（光伏设备）
 */
export const getDeviceList = (options) => {
  let projectId = options.projectId ?? null
  let name = options.name ?? null
  let groupId = options.groupId ?? null
  let enabled = options.enabled ?? null
  let onlineType = options.onlineType ?? null
  let switchState = options.switchState ?? null
  let alarmState = options.alarmState ?? null
  let size = options.size ?? 500
  let current = options.current ?? 1
  let url = `/api/zxy/solar/solar-device-info/find-summary-page`
  return instance.post(url, {
    model: {
      projectId, // 项目id
      name, // 设备名称
      groupId, // 分组ID
      enabled, // 启用状态,true/启用， false/停用
      onlineType, // 在线离线类型,可用值:ON,OFF
      switchState, // 单灯设备状态,开关状态，true/开灯，false/关灯
      alarmState, // 是否告警，告警状态,正常/false,告警/true
    },
    size,
    current
  })
}
/**
 * 根据SN获取智芯云设备数据
 */
export const getDeviceDetail = (sn) => {
  console.log('智芯云设备数据zxyToken', zxyToken)
  return instance.get(`/api/zxy/solar/solar-device-status/live/sn/${sn}`)
}
/**
 * 设置设备参数
 */
export const setSolarDeviceParams = (options) => {
  return instance.post('/api/zxy/solar/solar-device-status/save-param-down', {
    sn: options.sn,
    deviceParam: {
      ledRatedCurrent: options.ledRatedCurrent,
      volVoltageSet: options.volVoltageSet,
      editType: options.editType,
      batteryType: options.batteryType,
      batteryVoltage: options.batteryVoltage,
      batteryOverVoltage: options.batteryOverVoltage * 1000,
      batteryOverResumeVoltage: options.batteryOverResumeVoltage * 1000,
      batteryLowResumeVoltage: options.batteryLowResumeVoltage * 1000,
      batteryLowVoltage: options.batteryLowVoltage * 1000,
      dayThreshold: options.dayThreshold * 1000,
      nightThreshold: options.nightThreshold * 1000
    }
  })
}
/**
 * 设置设备时控策略-储能
 */
export const setDeviceStrategy = (options, mqttConfigId = 2) => {
  const property = {
    gridOutStrategyPropertyDownDto: {
      data: options.strategyTimeDetail
    }
  }
  return instance.post('/api/zxy/device-command-energy/down-energy', {
    deviceSns: [options.sn],
    mqttModel: 'V260_UPS',
    mqttConfigId, // 1-智赋EMQX，2-超本乐
    waitReply: false,
    protocolType: 'ENERGY_GRID_STRATEGY_SET',
    property
  })
}
/**
 * 读取设备状态
 * @param {string[]} deviceSns - 设备sn数组
 * @param {string} mqttModel - 设备类型即MQTT主题：SN_SOLAR,V260,V260_UPS
 * @param {string} mqttConfigId - 1-智赋EMQX，2-超本乐
 * @param {string} protocolType - 光伏云协议类型：
 * @param {boolean} waitReply - 是否等待响应
 */
export const getStatus = (deviceSns, mqttConfigId = 2) => {
  return instance.post(`/api/zxy/device-command-energy/down-energy`, {
    deviceSns,
    mqttModel: 'V260_UPS',
    mqttConfigId, // 1-智赋EMQX，2-超本乐
    waitReply: config.waitReply,
    timeout: config.timeout,
    protocolType: 'ENERGY_OPERATE_STATUS'
  })
}
/**
 * 控制AC端输出
 * @param {string[]} deviceSns - 设备sn数组
 * @param {string} mqttModel - 设备类型即MQTT主题：SN_SOLAR,V260,V260_UPS
 * @param {string} mqttConfigId - 1-智赋EMQX，2-超本乐
 * @param {string} protocolType - 光伏云协议类型：
 * @param {boolean} waitReply - 是否等待响应
 * @param {Object} property
 * @param {Object} property.offGridSwitchSetPropertyDownDto - 控制AC输出
 * @param {number} property.offGridSwitchSetPropertyDownDto.offGridSwitchType open-开，CLOSE-关
 */
export const outputControlAC = (deviceSns, offGridSwitchType, mqttConfigId = 2) => {
  return instance.post(`/api/zxy/device-command-energy/down-energy`, {
    deviceSns,
    mqttModel: 'V260_UPS',
    mqttConfigId, // 1-智赋EMQX，2-超本乐
    waitReply: config.waitReply,
    timeout: config.timeout,
    protocolType: 'ENERGY_OFF_GRID_SWITCH_SETTING',
    property: {
      offGridSwitchSetPropertyDownDto: {
        offGridSwitchType
      }
    }
  })
}
/**
 * 控制DC端输出
 * @param {string[]} deviceSns - 设备sn数组
 * @param {string} mqttModel - 设备类型即MQTT主题：SN_SOLAR,V260,V260_UPS
 * @param {string} mqttConfigId - 1-智赋EMQX，2-超本乐
 * @param {string} protocolType - 光伏云协议类型：
 * @param {boolean} waitReply - 是否等待响应
 * @param {Object} property
 * @param {Object} property.batterySwitchSetPropertyDownDto - 控制DC输出
 * @param {number} property.batterySwitchSetPropertyDownDto.batterySwitchType open-开，CLOSE-关
 */
export const outputControlDC = (deviceSns, batterySwitchType, mqttConfigId = 2) => {
  return instance.post(`/api/zxy/device-command-energy/down-energy`, {
    deviceSns,
    mqttModel: 'V260_UPS',
    mqttConfigId, // 1-智赋EMQX，2-超本乐
    waitReply: config.waitReply,
    timeout: config.timeout,
    protocolType: 'ENERGY_BATTERY_SWITCH_OUTPUT_SET',
    property: {
      batterySwitchSetPropertyDownDto: {
        batterySwitchType
      }
    }
  })
}
/**
 * 查询设备对应的传感器数据
 */
export function getSensorByDevice(deviceId) {
  return instance.get(`/api/zxy/assets/sensor-info/find-by-device-id/${deviceId}`)
}
/**
 * 根据ID查询传感器
 */
export function getSensorDetail(id) {
  return instance.get(`/api/zxy/assets/sensor-info/${id}`)
}
/**
 * 下发气象百叶盒-rs485
 */
export const downWphy = (sn) => {
  return instance.get(`/api/zxy/device-command-sensor-wpyh/down/${sn}`)
}
/**
 * 下发光照二氧化碳-rs485
 */
export const downHumidityCo2 = (sn) => {
  return instance.get(`/api/zxy/device-command-sensor-temp-humidity-co2/down/${sn}`)
}
/**
 * 下发土壤传感器-rs485
 */
export const downSoid = (sn) => {
  return instance.get(`/api/zxy/device-command-sensor-soil/down/${sn}`)
}
/**
 * 下发风速聚碳传感器-rs485
 */
export const downFsjt = (sn) => {
  return instance.get(`/api/zxy/device-command-sensor-fsjt/down/${sn}`)
}
/**
 * 下发风向聚碳传感器-rs485
 */
export const downFxjt = (sn) => {
  return instance.get(`/api/zxy/device-command-sensor-fxjt/down/${sn}`)
}
/**
 * 获取RS485传感器数据-rs485
 */
export const sensorDeviceRecord = (options) => {
  return instance.post(`/api/zxy/sensor/sensor-device-status-record/detail`, {
    sn: options.sn,
    deviceSensorType: options.deviceSensorType
  })
}
/**
 * 查询数据统计-按单天或区间-传感器设备
 * 参数：snHex, beginDateTime, endDateTime
 */
export const getSensorDeviceStatusRecord = (...args) => {
  let url = `/api/zxy/sensor/sensor-device-status-record/find-his`
  if (args.length === 4) {
    // 按区间查询
    return instance.post(url, {
      sn: args[0], 
      beginDateTime: args[1],
      endDateTime: args[2],
      deviceSensorType: args[3]
    })
  } else {
    // 按单天查询
    return instance.post(url, {
      sn: args[0], 
      dateTimeSingle: args[1],
      deviceSensorType: args[2]
    })
  }
}
/**
 * 设置设备参数-储能（控制功率输出）
 */
export const setEnergyDeviceParams = (options) => {
  return instance.post('/api/zxy/solar/solar-device-status/save-param-down', {
    sn: options.sn,
    maintainWorkParam: {
      maintain: 'NONE',
      maintainClose: 'NONE',
      maintainCircuitProtection: options.maintainCircuitProtection,
    },
    deviceParam: {
      batteryType: options.batteryType,
      batteryVoltage: options.batteryVoltage,
      batteryOverVoltage: options.batteryOverVoltage * 1000,
      batteryOverResumeVoltage: options.batteryOverResumeVoltage * 1000,
      batteryLowResumeVoltage: options.batteryLowResumeVoltage * 1000,
      batteryLowVoltage: options.batteryLowVoltage * 1000,
    },
    inverterWork: options.inverterWork
  })
}
// 分页列表查询-储能设备
export const getDeviceAlarmRecord = (options) => {
  let deviceName = options.deviceName ?? null
  let alarmStateType = options.alarmStateType ?? null
  let alarmState = options.alarmState ?? null
  let snList = options.snList ?? null
  let size = options.size ?? 300
  let current = options.current ?? 1
  return instance.post('/api/zxy/solar/solar-device-alarm-record/page', {
    model: {
      deviceName, // 设备名称
      alarmStateType, // 告警状态类型-枚举
      alarmState, // 告警处理状态-枚举,可用值:TRIGGERED,RESOLVED
      snList, // SN号数组
    },
    size,
    current
  }, {
    headers: {
      projectId: options.projectId
    }
  })
}
/**
 * 批量查询
*/
export const getStrategyList = (projectId) => {
  return instance.post('/api/zxy/solar/project-strategy-info/query', {
    projectId
  }, {
    headers: {
      projectId
    }
  })
}
/**
 * 根据Sn号批量下发策略，并保存策略
*/
export const downDeviceStrategy = (deviceId, strategyId, projectId) => {
  return instance.post('/api/zxy/solar/project-strategy-info/down-device-batch-strategy', {
    deviceIds: [deviceId],
    strategyId
  }, {
    headers: {
      projectId
    }
  })
}
/**
 * 查询数据统计-按单天或区间-储能设备
 * 参数：snHex, beginDateTime, endDateTime

 */
export const getEnergyDeviceStatusRecord = (...args) => {
  console.log(args)
  let url = `/api/zxy/solar/solar-device-status-record/statistics-data`
  if (args.length === 4) {
    // 按区间查询
    url = `/api/zxy/solar/solar-device-statistics/calc-his-statistics`
    return instance.post(url, {
      snHex: args[0],
      beginDateTime: args[1],
      endDateTime: args[3]
    }, {
      headers: {
        projectId: args[2]
      }
    })
  } else {
    // 按单天查询
    return instance.post(url, {
      snHex: args[0],
      dateTimeSingle: args[1]
    }, {
      headers: {
        projectId: args[2]
      }
    })
  }
}
/* ====================================调用智芯云V300设备数据 END============================================= */

const zxy = {
  getBmsInfoDb,
  getBmsInfoMote,
  getBmsInfoHistory,
  getBmsWarnDb,
  deleteDeviceEmitZxy,
  deleteBatchDeviceEmitZxy,
  login,
  getDeviceDetail,
  getStatus,
  setSolarDeviceParams,
  setDeviceStrategy,
  outputControlAC,
  outputControlDC,
  getDeviceList,
  getSensorByDevice,
  getSensorDetail,
  sensorDeviceRecord,
  downWphy, downHumidityCo2, downSoid, downFsjt, downFxjt,
  getSensorDeviceStatusRecord,
  setEnergyDeviceParams,
  getDeviceAlarmRecord,
  getStrategyList,
  downDeviceStrategy,
  getEnergyDeviceStatusRecord
}
export default zxy
